import React from 'react'
import { Route, Routes } from 'react-router-dom'
import CrmPage from '../../pages/features/crm/CrmPage'

export default function CrmNav() {
  return (
    <Routes>
         <Route path="/" element={<CrmPage />} />
   
       </Routes>
  )
}
